import React from 'react'
import ReactDOM from 'react-dom/client'
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { PortalApp } from './portal/PortalApp'
import { IS_PORTAL } from './config/app-role'
import './index.css'
import './i18n'
const queryClient: QueryClient = new QueryClient({
  // Her başarılı yazma (POST/PUT/PATCH/DELETE) sonrası veriler yenilenir; sayfalara tek tek invalidate yazmaya gerek kalmaz.
  // Veri yerel olduğu için ek istek ucuz. Etkin sorgular hemen çekilir, diğerleri bir sonraki açılışta.
  mutationCache: new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries({ predicate: (q) => !String(q.queryKey[0]).startsWith('ai-') })
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 dakika
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        {/* Bulut build'i Pusula Portal'dır; ERP arayüzü masaüstü Veri Merkezinde */}
        {IS_PORTAL ? <PortalApp /> : <App />}
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />}
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
